export default "__VITE_ASSET__Dc_TCzqz__"